import React, { useState, useEffect } from "react";
import axios from "axios";
import UpdateSecret from "./UpdateSecret";
import { config } from "../../../../../config";

const apiUrl = config.apiUrl;

const ViewSecrets = ({onSecretUpdated}) => {
  const [secrets, setSecrets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingSecret, setEditingSecret] = useState('');
  const [formData, setFormData] = useState({
    slug:'',
    headline:'',
    items:[{items:''}] 
  });

  const fetchSecrets = async () => {
    try {
      const response = await axios.get(`${apiUrl}/secrets`);
      setSecrets(response.data);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to load secrets");
    } finally {
      setLoading(false);
    }
  };
  
  // useEffect এ initialize করার সময়
  useEffect(() => {
    fetchSecrets();
  }, []);
  

  const handleEdit = (secret) => {

    setEditingSecret(secret.id)
    setFormData({
        slug:secret.slug,
        headline:secret.headline,
        items: secret.items 
    })
    
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      // Filter out empty items
      const itemsToSubmit = formData.items.filter(item => item.items.trim() !== "");

      const dataToSend = {
        slug: formData.slug,
        headline: formData.headline,
        items: itemsToSubmit
      };

      const response = await axios.put(`${apiUrl}/secretsupdate/${editingSecret}`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (onSecretUpdated) {
        onSecretUpdated();
      }
      await fetchSecrets();
      alert("Secret updated successfully!");
      
      setEditingSecret(null);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "An error occurred while updating the secret.");
    } finally {
    }
  };


  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this secret?")) return;
    
    try {
      await axios.delete(`${apiUrl}/secretdelete/${id}`);
      setSecrets(secrets.filter(secret => secret.id !== id));
      alert("Secret deleted successfully");
    } catch (err) {
      setError(err.response?.data?.message || "Failed to delete secret");
    }
  };

  if (loading) {
    return <div className="p-6 text-center">Loading secrets...</div>;
  }

  if (error) {
    return <div className="p-6 text-red-500 text-center">{error}</div>;
  }

  return (
    <div className="p-6 max-w-6xl mx-auto bg-white shadow rounded">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">All Secrets</h2>

      </div>

      {secrets.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          No secrets found. Create your first secret.
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Slug</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Headline</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Items</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {secrets.map((secret) => (
                <tr key={secret.id}>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm font-medium text-gray-900">{secret.slug}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-500">{secret.headline}</div>
                  </td>
                  <td className="px-6 py-4">
                    <ul className="text-sm text-gray-500">
                      {secret.items.map((item, index) => (
                        <li key={index} className="mb-1">• {item.items}</li>
                      ))}
                    </ul>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">

                    <button
                      onClick={() => handleEdit(secret)}
                     className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 mr-2"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(secret.id)}
                      className="text-red-600 hover:text-red-900"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

    {editingSecret && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center p-4 z-50 max-h-screen overflow-y-auto">
          <div className="p-6 mx-auto bg-white shadow rounded-lg min-w-[800px]">
            <UpdateSecret
              formData={formData}
              setFormData={setFormData}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              loading={loading}
              error={error}
              onCancel={() => setEditingSecret(null)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewSecrets;